import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { ManaulPage } from "./manaul";

@NgModule({
  declarations: [ManaulPage],
  imports: [IonicPageModule.forChild(ManaulPage), TranslateModule.forChild()],
})
export class ManaulPageModule {}



// WEBPACK FOOTER //
// ./src/pages/manaul/manaul.module.ts